import React from 'react';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface BasicModalProps {
  isOpen: boolean;
  modalLabel?: string;
  modalText?: string;
  firstButtonText: string;
  secondButtonText: string;
  onFirstButtonClick: () => void;
  onSecondButtonClick: () => void;
  handleClose: () => void;
  centeredText?: boolean;
}

export const BasicModal: React.FC<BasicModalProps> = ({
  isOpen,
  handleClose,
  modalLabel,
  modalText,
  firstButtonText,
  onFirstButtonClick,
  secondButtonText,
  onSecondButtonClick,
  centeredText,
}) => {
  return (
    <Dialog maxWidth={'xs'} open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: '0 0.5',
        }}
      >
        <Typography
          sx={{ ml: 2, flex: 1 }}
          color={'primary'}
          variant="h6"
          component="span"
        >
          {modalLabel}
        </Typography>
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ minWidth: 350, p: 2 }}>
        <Typography
          sx={{ mb: 2, textAlign: centeredText ? 'center' : 'inherit' }}
        >
          {modalText}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button
            variant={'contained'}
            sx={{ minWidth: 130 }}
            onClick={onFirstButtonClick}
          >
            {firstButtonText}
          </Button>
          <Button
            variant={'contained'}
            sx={{ minWidth: 130 }}
            onClick={onSecondButtonClick}
          >
            {secondButtonText}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
